'use strict';

module.exports = ['Room', 'Mezzanine', 'Patio/Terrace', 'Rooftop', 'Full Venue', 'Section', 'Nook', 'Outdoors', 'Balcony', 'Large Party Table', 'Floor/Level', 'Bar'];